/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/**
 * LoginService - performs IMS SSO, Org Switch from the Login Service.
 */
export default class LoginService {
  constructor(serviceDomain) {
    this.loginServiceDomain = serviceDomain;
  }

  /**
   * Async method to handle org switching.
   * Each time an org switch occur, we need to call the Login Service to
   * authorize the req and update IMS session data
   * and Renga last logged tenant.
   * @async
   * @param {Object} orgUpdateReqBody Org Update request body.
   * @param {string} imsAccessToken IMS access token: to authenticate request.
   * @returns {Promise} JSON object.
   */
  async changeOrg(orgUpdateReqBody, imsAccessToken) {
    try {
      const response = await fetch(`${this.loginServiceDomain}/exc-session/imsorgupdate`, {
        body: JSON.stringify(orgUpdateReqBody),
        headers: {
          Authorization: `Bearer ${imsAccessToken}`,
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });
      return response.json();
    } catch (error) {
      //console.error('Failed to update org: ', error);
    }
  }
}
